import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Location} from '@angular/common';
import {Observable} from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FormularNichtGespeichertGuard  {
  constructor(
    private readonly location: Location,
    private readonly router: Router
  ) {
  }

  canDeactivate(component: CanComponentDeactivate,
                route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot) {
    return this.memorizedHistoryCanDeactivate(route, component);
  }

  /**
   * Es gibt ein Bug im Angular-Framework:
   * Browser löscht den letzten Historieneintrag, trotz abgelehnter canDeactivate-Aufruf
   * @param route
   * @param comp
   */
  private memorizedHistoryCanDeactivate(route, comp): Observable<boolean> | boolean {
    const currentUrlTree = this.router.createUrlTree([], route);
    const currentUrl = currentUrlTree.toString();
    this.location.go(currentUrl);

    return comp.canDeactivate ? comp.canDeactivate() : true;
  }
}
